module.exports = __webpack_public_path__ + "img/curved-rail-horizontal-right-bottom-stone-path-background-remnants.2e68a319.png";